<bnd-modal
  [open]="open()"
  (closed)="onDismiss()"
  [title]="'DIALOG.NOTE.TITLE' | translate"
  size="md"
>
  @if (form.get('note')) {
    <form [formGroup]="form">
      <bnd-textarea formControlName="note" />
    </form>
  }
  <div
    modal-footer
    class="flex justify-end gap-4"
  >
    <bnd-button
      type="button"
      (click)="onCancel()"
    >
      {{ 'DIALOG.BUTTON.CANCEL' | translate }}
    </bnd-button>
    <bnd-button
      type="button"
      color="primary"
      (click)="save()"
      [disabled]="!form.get('note') || form.invalid"
    >
      {{ 'DIALOG.BUTTON.OK' | translate }}
    </bnd-button>
  </div>
</bnd-modal>
